export const commonMessage = {
  videoDeviceNotAvailable:
    "No video device found. Please check your browser permissions or ensure that your webcam is connected properly.",
  audioDeviceNotAvailable:
    "No audio device found. Please check your browser permissions or ensure that your microphone is connected properly.",
  noAudioVideoDeviceFound:
    "No audio/video device found. Please check your browser permissions or ensure that your microphone/webcam is connected properly.",
};
